<template><section><h1>Tabs</h1>
<blockquote>
<p>标签页</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<h3>Tabs</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td style="text-align:left">标签类型，可选值<code>padding/no_padding/fix_width/fix_width:String</code></td>
<td><code>String</code></td>
<td><code>padding</code></td>
</tr>
<tr>
<td>active-style</td>
<td style="text-align:left">选中时标签样式</td>
<td><code>Object</code></td>
<td>-</td>
</tr>
<tr>
<td>shouldChange</td>
<td style="text-align:left">标签切换前调用，返回false时则不切换标签[@params: name, vm]</td>
<td><code>Function</code></td>
<td>-</td>
</tr>
</tbody>
</table>
<h3>TabPane</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td style="text-align:left">标签Value，用于识别当前面板，默认为索引值</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>icon</td>
<td style="text-align:left">前置图标</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td style="text-align:left">是否禁用标签</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Tabs.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-25.vue?3c044afc